import { render, staticRenderFns } from "./FeaturedHeader.vue?vue&type=template&id=2e3c62a7&"
import script from "./FeaturedHeader.vue?vue&type=script&lang=js&"
export * from "./FeaturedHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e3c62a7')) {
      api.createRecord('2e3c62a7', component.options)
    } else {
      api.reload('2e3c62a7', component.options)
    }
    module.hot.accept("./FeaturedHeader.vue?vue&type=template&id=2e3c62a7&", function () {
      api.rerender('2e3c62a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/FeaturedHeader.vue"
export default component.exports